import config from '../../../config';

const logLevels = {
    trace: 0,
    debug: 1,
    info: 2,
    warn: 3,
    error: 4,
};

const defaultLogLevel = (__CONFIG_SOURCE__ === 'production' || __CONFIG_SOURCE__ === 'prod') ? logLevels.error : logLevels.debug;

const configuredLogLevel = logLevels[config.logLevel];
const logLevel = configuredLogLevel || defaultLogLevel;

class Log {
    constructor() {
        this.logLevel = logLevel;
    }
}

Object.keys(logLevels).forEach((level) => {
    Log.prototype[level] = function logger(...args) {
        const loggingFunction = () => {
            if (logLevels[level] >= this.logLevel) {
                console.log(`[${level}]`, ...args);
            }
        };
        return loggingFunction();
    };
});

export default new Log();
